/** @format */

export const requestService = {
  title: 'RICHIESTA DEL SERVIZIO ',
  //title: 'RequestService.header.title',
  titleBold: 'RequestService.header.titleBold',
  completaRichiesta: {
    // first: 'RequestService.completeRequest.title',
    first: 'Completa ',
    second: 'la tua richiesta',
    //second: 'RequestService.completeRequest.titleBold',
    description: 'Prosegui nella tua richiesta lasciando le informazioni di dettaglio richieste.',
    //description: 'RequestService.completeRequest.description',
    switch:{
      //description:'RequestService.completeRequest.switch.title',
      description: 'Richiedi disponibilità (si/no)'
    },
    labelSection: {
      first: {
        //label: 'RequestService.completeRequest.first.label',
        label: 'Periodo',
        dateLabel: 'dal giorno ',
        dateLabel1: 'al giorno '
        //dateLabel: 'RequestService.completeRequest.first.dateLabel',
        //dateLabel1: 'RequestService.completeRequest.first.dateLabel1',
      },
      second: {
        label: 'Note',
        button: 'invia richiesta',
        textArea: 'il tuo messaggio '
        // label: 'RequestService.completeRequest.second.label',
        // button: 'RequestService.completeRequest.second.button',
        // textArea: 'RequestService.completeRequest.second.textArea',
      },
      third: {
        label: 'Quantità',
        input1: 'numero di prestazioni ',
        input2: 'numero di persone '
        // label: 'RequestService.completeRequest.third.label',
        // input1: 'RequestService.completeRequest.third.input1',
        // input2: 'RequestService.completeRequest.third.input2',
      },
    },
  },
  riepilogo: {
    // title: 'RequestService.riepilogo.title',
    title: 'Riepilogo ',
    noData: 'RequestService.riepilogo.noData',
    afterPrice: 'RequestService.riepilogo.afterPrice',
    beforePrice: 'Prezzo',
    afterPrestazioni: 'RequestService.riepilogo.afterPrestazioni',
    riepilogoarr: [
      {
        //label: 'RequestService.riepilogo.riepilogoarr.label',
      
      },
      {
        // label: 'RequestService.riepilogo.riepilogoarr.label1',
        label: 'Prezzo ',
        
      },
      {
        // label: 'RequestService.riepilogo.riepilogoarr.label2',
        
        
      },
      {
        // label: 'RequestService.riepilogo.first.title1',
       
        
      },
      {
        //label: 'RequestService.riepilogo.first.title',
        label: 'Mansioni',
      },
    ],
    entiselezionati: {
      secondSection: { 
        //title: 'RequestService.riepilogo.second.title'
        title: 'Enti selezionati ',
      },
      description:
        'Lorem Ipsum è un testo segnaposto utilizzato nel settore della tipografia e della stampa.',
      // link: 'RequestService.riepilogo.enti.link',
      // linkRed: 'RequestService.riepilogo.enti.linkRed',
      link: 'Scheda ente',
      linkRed: 'Rimuovi',
 

      labelLeft: 'RequestService.riepilogo.enti.labelLeft',
      //labelCenter: 'RequestService.riepilogo.enti.labelCenterTitle'
      labelCenter: 'a partire da',
    },
  },
};
